import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState } from './reducer';

const selectHomeDomain = state => state.Home || initialState;

const selectHomePerformances = () => createSelector(selectHomeDomain, subState => get(subState, 'performances'));

const selectHomeNumbers = () =>
  createSelector(selectHomeDomain, subState => {
    const artists = get(subState, 'homeNumbers.artists.total');
    const performances = get(subState, 'homeNumbers.performances.total');
    const companies = get(subState, 'homeNumbers.companies.total');
    const festivals = get(subState, 'homeNumbers.festivals.total');
    const managers = get(subState, 'homeNumbers.managers.total');
    return { artists, performances, companies, festivals, managers };
  });

const selectArtists = () => createSelector(selectHomeDomain, subState => get(subState, 'artists'));
const selectHighlights = () => createSelector(selectHomeDomain, subState => get(subState, 'highlights'));

export { selectHomePerformances, selectHomeNumbers, selectArtists, selectHighlights };
